import { RouteRecordRaw } from 'vue-router';
import { WebSocketSandboxPage } from '@/pages/sandbox';

export const routeName = 'WebSocketSandbox';

export const route: RouteRecordRaw = {
  path: 'sandbox/websocket',
  name: routeName,
  component: WebSocketSandboxPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'WebSocket Monitor',
  },
};
